// Framework and third-party non-ui
import React, { useContext, useEffect, useState } from 'react';
import { loadModules } from 'esri-loader';
import { getFeaturedRoutes } from 'data/map';

// App components
import { UserContext } from 'contexts/UserContext';
import FeaturedRoute from 'components/FeaturedRoute';
import { CircularProgress } from '@material-ui/core';

// Third-party components (buttons, icons, etc.)
import { Virtuoso } from 'react-virtuoso';
import AutoSizer from 'react-virtualized-auto-sizer';

const FeaturedList = () => {
  const { userInfo } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [featuredRoutes, setFeaturedRoutes] = useState([]);
  const [favoritedRoutes, setFavoritedRoutes] = useState([]);

  useEffect(() => {
    if(userInfo  && userInfo.favoritesUrl){
      (async () => {
          const [esriRequest] = await loadModules(['esri/request']);
          let res = await esriRequest(userInfo.favoritesUrl + '/query',{
            method: 'post',
            query: {
              where: 'IsFeaturedTrail = 1',
              f:"json", // format
              token: userInfo.credential.token,
            },
          })
          setFavoritedRoutes(res.data.features.map(feature => feature.attributes.TrailID));
      })();
    }
  }, []);

  useEffect(() => {
    if(userInfo && userInfo.favoritesUrl){
        (async () => {
            const [esriRequest] = await loadModules(['esri/request']);
            let res = await esriRequest(userInfo.favoritesUrl + '/query',{
              method: 'post',
              query: {
                where: 'IsFeaturedTrail = 1',
                f:"json", // format,
                token: userInfo.credential.token,
              },
            })
            setFavoritedRoutes(res.data.features.map(feature => feature.attributes.TrailID));
        })();
      }
    }, [userInfo]);

  useEffect(() => {
    (async () => {
      let featuredRoutes = await getFeaturedRoutes();
      setFeaturedRoutes(featuredRoutes.features);
      setLoading(false);
    })();
  }, []);

  const getIcons = (attributes) => {
    const attrs = ['WHEELCHAIR_FRIENDLY', 'DOGS', 'SNOWMOBILES', 'BIKES', 'HORSES', 'OFF_ROAD_4X4', 'XC_SKIING', 'STATUS'];
    const icons = {};
    attrs.forEach(attr => {
      if(['Yes', 'Var', 'Recmnd', 'Allow', 'Open'].includes(attributes[attr])){
        icons[attr] = true;
      }else{
        icons[attr] = false;
      }
    });
    return icons;
  };

  const isFavorited = (trailId) => {
    return favoritedRoutes.includes(trailId);
  };

 // if (!filteredFeatureList.length) return (<StyledNoResults>Sorry, no trails found...</StyledNoResults>);

  const Row = (index) => {
    const feature = featuredRoutes[index];
    return (
        <FeaturedRoute 
            key={feature.attributes.PRIMARY_TRAIL_ID}
            feature={feature} 
            attributes={feature.attributes} 
            icons={getIcons(feature.attributes)} 
            favorited={isFavorited(feature.attributes.PRIMARY_TRAIL_ID)} 
            setFavoritedRoutes={setFavoritedRoutes} 
            favoritedRoutes={favoritedRoutes}
            loggedIn={userInfo ? true: false}
          />
    );
  };

  return (
    <>
        {loading ? <CircularProgress color="inherit" style={{position: 'relative', top: '60px'}}/> :
            (
                <AutoSizer style={{position: 'relative', top: '60px'}}>
                {({ width, height }) => (
                    <Virtuoso
                    style={{ width, height }}
                    totalCount={featuredRoutes.length}
                    item={Row}
                    overscan={500}
                    >
                    </Virtuoso>
                )}
                </AutoSizer>
            )
        }
    </>
  );
};

export default FeaturedList;

